import React, {useEffect, useReducer, useState} from 'react';
import {Balloon, Button, DatePicker, Dialog, Form, Icon, Input, Notification, Radio, Select, Table} from '@alifd/next';
import Styles from './index.module.scss';
import { Servlets } from '@/service/index';
import LabelCon from '../crowdManage/LabelCon';
import LzPagination from '@/components/common/LzPagination';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import LzMsg from '@/components/common/LzMsg';
import ParagraphTitle from '@/components/ParagraphTitle'; // hjyt- 添加
import utils from '@/common/utils'; // hjyt- 添加
import { store } from '@ice/stark-data';
import styles from "@/pages/PhoneUpload/index.module.scss";
import {history} from "ice";

const RadioGroup = Radio.Group;

export default () => {
  const history = useHistory();
  // 提示弹窗
  const tips = (type, content, title) => {
    Notification.open({
      title,
      content,
      type,
    });
  };

  // 分页信息
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // history.push(`/public/sms/market/task/create`,modelData)
  // 是否触发表格的loading
  const [isLoading, setIsLoading] = useState(false);

  // 人群列表数据
  const [crowdListData, getcrowdlist]:any = useState([]);

  // 请求参数获取
  const [fetchParams, setFetchParams] = useState({
    crowdName: '',
    startTime: '',
    endTime: '',
    pageNo: 1,
    pageSize: 10,
    type: '',
  });
  // 搜索参数
  const [searchParams, setSearchParams] = useState(
    {
      crowdName: '',
      startTime: '',
      endTime: '',
      pageNo: 1,
      pageSize: 10,
      type: '',
    },
  );
  // 删除数据Id
  const [removeId, getRemoveId] = useState([]);
  // 批量删除id
  const [cancelCrowdList, setCancelCrowdList] = useState([]);
  // 查看对应id
  // 表单
  const FormItem = Form.Item;
  // 时间选择器
  const { RangePicker, MonthPicker, YearPicker, WeekPicker } = DatePicker;
  // pin上传人群，人群复制dialog显示
  const [crowdDialog, setCrowdDialog] = useState(false);
  // 查询
  const search = (values, errors) => {
    fetchParams.crowdName = values.name ? values.name : '';
    fetchParams.type = values.type ? values.type : '';
    // 转换为时间戳
    fetchParams.startTime = values.year && values.year[0] ? values.year[0]._d.getTime() : '';
    fetchParams.endTime = values.year && values.year[1] ? values.year[1]._d.getTime() : '';
    pageInfo.pageNo = 1;
    fetchCrowdList(fetchParams);
    setSearchParams(fetchParams);
  };


  /** 设置 Header 面包屑 */
  const setBreadcrumb = () => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '客户管理', // 一级页面名称
      url: '/web/CustomerManagement', // 一级页面url
      children: {
        name: '人群管理', // 二级页面名称
        url: '/web/CustomerManagement', // 二级页面url
      },
    });
  };
  const [refrshParams, setRefreshParams]:any = useState({
    description: '人群描述',
    name: '人群名称',
    id: 299,
  });
  // 复制人群
  const packageRefreshSubmit = () => {
    if (refrshParams.name.length > 32) {
      LzMsg.error('人群名称不可超过32个字')
    } else if (refrshParams.description.length > 32) {
      LzMsg.error('人群描述不可超过32个字')
    } else {
      Servlets('crowdpackreplica', refrshParams).then((res) => {
        if (res.success) {
          tips('success', '复制人群包成功', '成功');
        }
        setCrowdDialog(false);
        fetchCrowdList({ pageNo: 1, pageSize: pageInfo.pageSize });
      }).catch((e) => {
        tips('error', '请求失败，请稍后重试', '失败');
        setCrowdDialog(false);
      });
    }

  };
  // 查询人群列表
  const fetchCrowdList = (params) => {
    setIsLoading(true);
    // 接收参数
    const formData = {
      crowdName: params.crowdName,
      startTime: params.startTime,
      endTime: params.endTime,
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      type: params.type,
    };
    // 将参数更新
    const param = {
      ...formData,
      ...params,
    };
    // 请求接口
    Servlets('getDYCrowdList', param).then((res) => {
      if (res.success) {
        getcrowdlist(res.data);
        setIsLoading(false);
        setPageInfo({
          ...pageInfo,
          pageNo: res.page.pageNo,
          pageSize: res.page.pageSize,
          total: res.page.total,
        });
      } else {
        setIsLoading(false);
        LzMsg.error(res.resp_msg);
      }
    });
  };

  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      // TODO 请求后端列表接口
      fetchCrowdList({
        pageSize: pages.pageSize,
        pageNo: pages.pageNo,
        crowdName: searchParams.crowdName,
        startTime: searchParams.startTime,
        endTime: searchParams.endTime,
        type: searchParams.type,
      });
    } catch (e) {

    }
  };
  // 删除的dialog  visible是否显示
  const [deletevisible, setDelete] = useState(false);
  // 删除 按钮继续
  const onRemove = (removeId) => {
    setIsLoading(true);
    if (removeId.length !== 0) {
      // 请求删除接口
      Servlets('DeleteCrowdById', { ids: removeId }).then((res) => {
        // dialog不显示
        setDelete(false);
        if (res.success === true) {
          // 重新请求数据
          fetchCrowdList({ ...searchParams, pageNo: 1, pageSize: pageInfo.pageSize });
          LzMsg.success('删除成功');
        } else {
          setIsLoading(false);
          LzMsg.error(res.resp_msg);
        }
      });
    } else if (removeId.length === 0) {
      setIsLoading(false);
      LzMsg.error('请选择需要删除的人群');
    }
  };
  // 查看的dialog  visible是否显示
  const [lookvisible, setLook] = useState(false);
  const onLook = (record) => {

  };
  // cell 创建时间
  const createTime = (value, index, record) => {
    // 时间戳转化为时间
    const time = new Date(record.createTime);
    // 格式化时间
    const formatTime = `${time.toLocaleDateString().replace(/\//g, '-')} ${time.toTimeString().substr(0, 8)}`;
    return (
      <span>{formatTime}</span>
    );
  };
  // 人群类型cell
  const typecell = (value, index, record) => {
    if (record.type === 0) {
      return (<span>普通标签人群</span>);
    } else if (record.type === 2) {
      return (<span>pin上传人群</span>);
    } else if (record.type === 3) {
      return (<span>自主上传和已有包合并</span>);
    } else if (record.type === 4) {
      return (<span>交并差人群</span>);
    } else if (record.type === 5) {
      return (<span>AI模型人群</span>);
    }
  };
  // 人群状态 cell
  const status = (value, index, record) => {
    if (record.status === 0) {
      return (
        <span style={{ color: '#FF9900' }}>生成中</span>
      );
    } else if (record.status === -1) {
      return (
        <span style={{ color: '#FF3333' }}>生成失败</span>
      );
    } else if (record.status === 1) {
      return (
        <span style={{ color: '#00BB66' }}>已生成</span>
      );
    } else if (record.status === 2) {
      return (
        <span style={{ color: '#3399FF' }}>已投放</span>
      );
    }
  };

  /**
   *   去营销
   *   marketingType   1手机号和标签  2订单
   *   peopleCrowdType "人群营销下的人群类型 1-标签策略 2-手动上传",
   *   peopleCrowdParam  marketingType1    必传
   *
   *   orderCrowdType 1 订单筛选
   *   orderCrowdParam marketingType2    必传
   */
  const goMarketing = (record) => {
    const Params = { searchString: '', telList: [], orderCrowdType: '', marketingType: '', marketingTypeText: '人群营销',crowdId:record.crowdId};
    if (record.type === 1) { // 手机号上传
      Params.peopleCrowdType = '2';  // "人群营销下的人群类型 1-标签策略 2-手动上传",0-订单筛选,
      Params.marketingType = '1';  // "营销类型 1-人群营销 2-订单筛选营销",
      Params.orderCrowdType = '0';  // 0-订单营销下的筛选类型 1-手动选择 2-查询结果,
    } else if (record.type === 2) { // 官方标签创建
      Params.marketingType = '1';
      Params.peopleCrowdType = '1';
      Params.orderCrowdType = '0';
    } else if (record.type === 3) { // 官方人群
      Params.marketingType = '2';
      Params.orderCrowdType = '1';
      Params.peopleCrowdType = '0';
      Params.telList = Array.of((record.useLabel).substr(0, record.useLabel.length - 1));
    } else if (record.type === 4) { // 云鹿标签创建
      Params.marketingType = '1';
      Params.peopleCrowdType = '1';
      Params.orderCrowdType = '0';
    } else if (record.type === 5) { // 官方标签新
      Params.marketingType = '1';
      Params.peopleCrowdType = '1';
      Params.orderCrowdType = '0';
    }
    else if (record.type === 6) { // 云鹿转官方人群
      Params.marketingType = '1';
      Params.peopleCrowdType = '2';
      Params.orderCrowdType = '0';
    } else if (record.type === 7) { // 订单号生成云鹿人群
      Params.marketingType = '1';
      Params.peopleCrowdType = '2';
      Params.orderCrowdType = '0';
    } else if (record.type === 8) { //订单号生成官方人群
      Params.marketingType = '1';
      Params.peopleCrowdType = '2';
      Params.orderCrowdType = '0';
    } else if (record.type === 9) { // 手机号生成官方人群
      Params.marketingType = '1';
      Params.peopleCrowdType = '2';
      Params.orderCrowdType = '0';
    } else if (record.type === 10) { // 抖店openid生成官方人群
      Params.marketingType = '1';
      Params.peopleCrowdType = '2';
      Params.orderCrowdType = '0';
    } else if (record.type === 11) { // 抖店上传人群
      Params.marketingType = '1';
      Params.peopleCrowdType = '2';
      Params.orderCrowdType = '0';
    }

    store.set('fromUrlToCreateMarket', '/CustomerManagement');
    store.set('sceneMarketingParams', Params);
    sessionStorage.setItem('LzCrowdMarket', JSON.stringify(record)); // 把当前人群内容存进缓存，到新建官方人群营销使用

    if ([4,7].includes(record.type)) { // 云鹿人群
      history.push('/privateCrowdMarketing/create');
    } else {
      history.push('/crowdMarketing/create');
    }
  };

  /**
   * 复制标签生成的人群策略
   */
  const copyCrowdStrategy = (data, name, description) => {
    const obj = {
      list: JSON.parse(data),
      name,
      labelDescription: description
    }
    sessionStorage.setItem('LzCrowdEsIson', JSON.stringify(obj)); // 把当前标签内容存进缓存，到人群创建页使用
    history.push('/crowd/tag/copy');
  };

    /**
   * 复制标签生成的人群策略
   */
    const copyCrowdStrategyNew = (data, name, description,content) => {
      const obj = {
        list: JSON.parse(data),
        name,
        content:JSON.parse(content),
        labelDescription: description
      }
      sessionStorage.setItem('LzCrowdEsIson', JSON.stringify(obj)); // 把当前标签内容存进缓存，到人群创建页使用
      history.push('/crowd/newtag/copy?copy=true');
    };

  const copyYunluCrowdStrategy = (data, name, description) => {
    const obj = {
      list: JSON.parse(data),
      name,
      labelDescription: description
    }

    sessionStorage.setItem('YunLuCrowdEsJson', JSON.stringify(obj)); // 把当前标签内容存进缓存，到人群创建页使用
    history.push('/yunLu/crowd/tag/copy');
  };

  // 操作 cell
  const oprate = (value, index, record) => {
    return (
      <span>
        {
            record.type !== 3 &&
            <Button
              type="primary"
              text
              className={Styles.textbtn}
              onClick={() => {
                setDelete(true);
                getRemoveId([record.id]);
              }}
            >
              删除
            </Button>
        }
        {
          (record.type === 2 || record.type === 3) &&
          <Button
            type="primary"
            text
            className={Styles.textbtn}
            onClick={() => {
              setCrowdDialog(true);
              setRefreshParams({
                ...refrshParams,
                id: `${record.id}`,
                description: `${record.description}副本`,
                name: `${record.name}副本`,
              });
            }}
          >复制
          </Button>
        }
        {
          (record.type === 5) &&
          <Button
            type="primary"
            text
            className={Styles.textbtn}
            onClick={() => {
              copyCrowdStrategyNew(record.useLabel, record.name, record.description, record.content);
            }}
          >复制
          </Button>
        }
        {
          (record.type === 1) && <Button
            type="primary"
            text
            className={Styles.textbtn}
            onClick={() => {
              copyCrowdStrategy(record.useLabel, record.name, record.description);
            }}
          >复制
          </Button>
        }
        {
          (record.type === 4) && <Button
            type="primary"
            text
            className={Styles.textbtn}
            onClick={() => {
              copyYunluCrowdStrategy(record.useLabel, record.name, record.description);
            }}
          >复制
          </Button>
        }
        {
          record.crowdStatus === 1 &&
          <Button
            type="primary"
            text
            className={Styles.textbtn}
            onClick={() => {
              goMarketing(record);
            }}
          >去营销
          </Button>
        }
        {
          ([4,7].includes(record.type) && record.crowdStatus == 1) &&
          <Button
            type="primary"
            text
            className={Styles.textbtn}
            onClick={() => {
              toOfficalCrows(record);
            }}
          >转成官方人群
          </Button>
        }
      </span>
    );
    // }
  };
  /**
   * 使用标签列
   */
  const labelsDescriptionRender = (value, index, item) => {
    return (<>
      {
        item.useLabelDescription
          ?
          (
            <Balloon
              align="t"
              closable={false}
              style={{ color: '#9ca7b6', paddingLeft: '5px' }}
              align="rb"
              trigger={
                <div>
                  <div style={{
                    width: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  >
                    {item.useLabelDescription}
                  </div>
                </div>
              }
            >
              <div style={{ padding: '0px 0px 10px 10px', textAlign: 'justify', color: '#9ca7b6' }}>
                {item.useLabelDescription}
              </div>
            </Balloon>
          )
          :
          '/'
      }
    </>);
  };
  // 参数：人群状态下拉列表
  const corwdStatus = [
    { value: 0, label: '生成中' },
    { value: 1, label: '已生成' },
    { value: 2, label: '已投放' },
    { value: '', label: '全部状态' },
    { value: -1, label: '生成失败' },

  ];
  // 查询参数：人群类型下拉列表
  const corwdType = [
    { value: 1, label: '官方标签筛选' },
    // { value: 2, label: '手机号上传' },
    { value: 3, label: '官方推荐人群' },
    { value: 4, label: '云鹿标签筛选' },
    { value: 5, label: '官方标签筛选（新）' },
    { value: 6, label: '云鹿转官方人群' },
    { value: 7, label: '订单号生成云鹿人群' },
    { value: 8, label: '订单号生成官方人群' },
    { value: 9, label: '手机号生成官方人群' },
    { value: 10, label: '抖店openid生成官方人群' },
  ];

  const formItemLayout = {
    labelAlign: 'top',
    labelCol: {
      fixedSpan: 8,
    },
    wrapperCol: {
      span: 14,
    },
  };
  const initFormData = {
    name : '',
    desc: '',
    crowdExpire: 1,
  };

  const [formData, setFormData] = useReducer((p, c) => {
    return {...p, ...c}
  }, initFormData);
  const [openIdCrowd, setOpenIdCrowd] = useState({});
  const [visible, setVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const onClose = () => {
    setVisible(false);
  };
  const onCrowdSubmit = () => {
    console.log(openIdCrowd, formData);
    if(!formData.name){
      LzMsg.error('请输入人群包名称')
      return;
    }
    if(!openIdCrowd.crowdId){
      LzMsg.error('请选取人群包')
      return;
    }
    setSubmitLoading(true);
    Servlets('toDyCrowd', {
      crowdId: openIdCrowd.crowdId,
      peopleName: formData.name,
      peopleDescription: formData.desc,
      crowdExpireType: formData.crowdExpire,
    }).then((res:any) => {
      console.log('res', res);
      if(res.success){
        fetchCrowdList({ crowdName: '', startTime: '', endTime: '', pageNo: 1, pageSize: 10, type: '', });
        setSubmitLoading(false);
        setTipVisible(true);
      } else {
        setSubmitLoading(false);
        tips('error', res.resp_msg, '失败');
      }
    }).catch((e) => {
      setSubmitLoading(false);
      console.log('e',e);
      tips('error', '请求失败，请稍后重试', '失败');
    });
  };

  const toOfficalCrows = (record) => {
    const currentTime = moment().format('MM月DD日 HH点mm分ss秒')
    setOpenIdCrowd(record);
    setFormData({
      name: `默认创建${currentTime}`,
      desc: `默认创建${currentTime}`
    });
    setVisible(true);
  }

  const [tipVisible, setTipVisible] = useState(false);
  const tipClose = () => {
    setTipVisible(false);
    setVisible(false);
  }

  const [longDayTimes, setLongDayTimes] = useState(0);
  const [shortDayTimes, setShortDayTimes] = useState(0);
  const getCrowdTimes = () => {
    Servlets('getCrowdTime', {}).then((res:any) => {
      if(res.success){
        console.log('res', res);
        setLongDayTimes(res.data.longDayTimes);
        setShortDayTimes(res.data.shortDayTimes);
      } else {
        tips('error', res.resp_msg, '失败');
      }
    }).catch((e) => {
      console.log('e',e);
      tips('error', '请求失败，请稍后重试', '失败');
    });
  }

  // 初始化渲染
  useEffect(() => {
    setBreadcrumb(); // 设置 Header 面包屑
    fetchCrowdList({ ...fetchParams });
  }, []);

  useEffect(() => {
    getCrowdTimes();
  }, [visible])

  return (
    <div>
      <div className={Styles.uploadCon}>
        <ParagraphTitle title="人群创建" />
        <div className={Styles.upload}>

          <LabelCon
            icon={'icon-icon5_huaban1'}
            title={'官方标签组合'}
            content={'通过筛选人群基础属性、行为特征、购买偏好，类目偏好等，帮您快速 锁定私域营销人群'}
            label={'34个标签可用'}
            show
            color={'#9580FF'}
          />
          <LabelCon
            icon={'icon-icon5_huaban1'}
            title={'云鹿标签组合'}
            content={'通过筛选下单时间、渠道、商品、件数等订单条件，帮您快速锁定不同维度的已购人群'}
            label={'5个标签可用'}
            show
            color={'#52CCA3'}
          />
          <LabelCon
            icon={'icon-icon5_huaban1'}
            title={'官方标签组合（新）'}
            content={'通过筛选人群基础属性、行为特征、购买偏好，类目偏好等，帮您快速 锁定私域营销人群'}
            label={'34个标签可用'}
            show
            color={'#cc5252'}
          />
          <LabelCon
            icon={'icon-icon5_huaban1'}
            title={'手动上传人群包'}
            content={'通过用户的订单号、手机号、抖店openid批量生成人群包'}
            label={'34个标签可用'}
            show
            color={'#d7d7d7'}
          />
          {/* <LabelCon
            icon={'icon-icon5_huaban2'}
            title={'用户手机号上传'}
            content={'支持使用用户手机号批量上传生成人群包，使用上传后的人群包进行批量营销'}
            label={''}
            show={false}
            color={'#52CCA3'}
          />
          <LabelCon
            icon={'icon-icon5_huaban2'}
            title={'用户订单筛选'}
            content={'支持筛选用户订单状态进行批量存为人群包，也可以直接使用筛选结果进行批量营销'}
            label={''}
            show={false}
            color={'#6699FF'}
          /> */}
        </div>
      </div>

      <div className={Styles.listSearch}>
        <Form inline className={`${Styles.listSearchForm} form-crowdMarketing`} size="medium">
          {/* <div style={{ display: 'flex' }}> */}
          <FormItem label="人群名称" className={Styles.formItem}>
            {/* <span style={{ marginRight: '15px' }}>人群名称:</span> */}
            <Input name="name" aria-label="Medium" className={Styles.formItem_width} />
          </FormItem>

          <FormItem label="创建时间" className={Styles.formItem}>
            {/* <span style={{ marginRight: '15px' }}>创建时间:</span> */}
            <RangePicker
              popupAlign="tc tc"
              name="year"
              showTime
              resetTime
              className={Styles.formItem_width}
              followTrigger
            />
            {/* <RangePicker name="year" showTime resetTime className={Styles.formItem_width} followTrigger/> */}
          </FormItem>

          {/* 下拉列表 人群类型  // defaultVisible = {true}  //下拉列表是否展开 */}
          <FormItem
            label="人群类型"
            className={Styles.formItem}
          >
            {/* <span style={{ marginRight: '15px' }}>人群类型:</span> */}
            <Select
              followTrigger
              defaultValue=""
              dataSource={corwdType}
              name="type"
              className={Styles.formItem_width}
            />
          </FormItem>
          {/* </div> */}
          <FormItem className={Styles.formItem}></FormItem>
          <FormItem className={Styles.formItem}></FormItem>
          <FormItem label="" className={Styles.formItem} style={{ textAlign: 'right' }}>
            <Form.Submit
              className={`${Styles.btn} ${Styles.submitBtnStyle_width} ${Styles.submitBtnStyle_marginRight}`}
              type="primary"
              onClick={search}
            >查询
            </Form.Submit>

            <Form.Reset
              className={`${Styles.btn} ${Styles.submitBtnStyle_width} `}
              onClick={() => {
                const obj = {
                  crowdName: '',
                  startTime: '',
                  endTime: '',
                  pageNo: 1,
                  pageSize: 10,
                  type: '',
                }
                setSearchParams({ ...obj });
                fetchCrowdList({ ...obj, pageNo: 1, pageSize: pageInfo.pageSize });
              }}
            >重置
            </Form.Reset>
          </FormItem>
        </Form>
      </div>
      <Form>
      </Form>

      <div className={Styles.tablecon}>
        {/* <div className={Styles.secondtitle} style={{ marginLeft: '0%', marginBottom: '15px' }}>
          公域人群库
        </div> */}
        <ParagraphTitle title="我的人群库" />

        <div style={{ padding: '0 40px' }}>
          <div className={Styles.cancelCrowdListBtn}>
            <Button
              type="secondary"
              style={{ marginLeft: '10px' }}
              onClick={() => {
                onRemove(cancelCrowdList);
              }}
            >批量删除
            </Button>
          </div>


          <div className="changetabcon">
            <Table
              dataSource={crowdListData}
              className={Styles.table}
              loading={isLoading}
              rowSelection={{
                onChange: (value) => {
                  // 改变选中list的值
                  setCancelCrowdList(value);
                },
              }}
            >
              <Table.Column title="人群名称" align="left" dataIndex="name" width="194" />
              <Table.Column title="人群描述" align="left" dataIndex="description" width="194" />
              <Table.Column
                title="人群类型"
                align="left"
                cell={(value, index, record) => (
                  <span>{corwdType.find((item) => item.value === record.type)?.label}</span>
                )}
                width="194"
              />
              <Table.Column title="使用标签" align="left" cell={labelsDescriptionRender} width="194" />
              <Table.Column
                title="人群总数量"
                align="left"
                cell={(value, index, record) => (
                  <span>{record.size.toLocaleString()}</span>
                )}
                width="194"
              />
              <Table.Column
                title="创建时间"
                align="left"
                cell={(value, index, record) => (
                  <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                )}
                width="194"
              />
              <Table.Column
                title="状态"
                align="left"
                cell={(value, index, record) => (
                  <span>{record.crowdStatus === 0 ? '不可用' : record.crowdStatus === 1 ? '可用' : record.crowdStatus === 2 ? '生成中' : '已过期'}</span>
                )}
                width="194"
              />
              <Table.Column
                title="已使用次数"
                align="left"
                cell={(value, index, record) => (
                  <span>{record.useCount.toLocaleString()}</span>
                )}
                width="194"
              />

              <Table.Column title="操作" align="left" cell={oprate} lock="right" width="194" />
            </Table>
          </div>
          <div style={{ paddingBottom: 40 }}>
            {/* 分页器 */}
            <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
          </div>


        </div>


        {/* Dialog:删除 */}
        <Dialog
          visible={deletevisible}
          style={{ width: '300px' }}
          height="150px"
          // Dialog底部自定义
          footer={
            <div>
              <Button
                warning
                type="secondary"
                onClick={() => {
                  setDelete(false);
                  getRemoveId([]);
                }}
              >
                取消
              </Button>&nbsp;
              <Button
                type="primary"
                onClick={() => {
                  onRemove(removeId);
                }}
              >
                继续
              </Button>
            </div>
          }
          onClose={() => {
            setDelete(false);
            getRemoveId([]);
          }}
        >
          {/* Dialog内容 */}
          <p><Icon type="warning" style={{ color: '#FF9900', paddingRight: '13px', display: 'inline' }} />删除后无法找回，是否确认删除
          </p>
        </Dialog>

        {/* Dialog:查看 lookvisible */}
        <Dialog
          visible={lookvisible}
          style={{ width: '300px' }}
          height="150px"
          onClose={() => {
            setLook(false);
          }}
        />

        {/* pin上传复制dialog */}
        <Dialog
          title="复制人群"
          className="quickDialog_hjy" // hjy添加
          visible={crowdDialog}
          footer={
            <div>
              <Button
                type="normal"
                style={{ marginRight: '10px', marginLeft: '10px', width: 88 }}
                onClick={() => {
                  setCrowdDialog(false);
                }}
              >取消
              </Button>
              <Button
                type="primary"
                style={{ width: 88 }}
                onClick={() => {
                  packageRefreshSubmit();
                }}
              >确认
              </Button>
            </div>
          }
          height="332px"
          onClose={() => {
            setCrowdDialog(false);
          }}
        >
          <div style={{ width: '100%', height: '100%', paddingTop: '10px', paddingLeft: '20px' }}>
            <div>
              <span style={{ fontFamily: 'PingFang SC Regular', color: '#000000' }}>注：复制的人群会在人群库中新生成一条包含相同用户的人群</span><br />
              {/* <span style={{ paddingLeft: '28px', fontFamily: 'PingFang SC Regular', color: '#000000' }}>2. 复制成功的人群会保存在人群管理-我的人群库中</span> */}
              <div style={{ width: '100%', display: 'flex', marginTop: '20px', flexDirection: 'column' }}>
                <span style={{ lineHeight: '30px', fontFamily: 'PingFang SC Regular', color: '#000000' }}><span
                  style={{ color: 'red' }}
                >*
                </span>人群名称：
                </span>
                <Input
                  onChange={(value) => {
                    setRefreshParams({ ...refrshParams, name: value });
                  }}
                  maxLength={32}
                  value={refrshParams.name}
                  hasLimitHint
                  style={{ width: '100%', borderRadius: '2px' }}
                />
              </div>
              <div style={{ width: '100%', display: 'flex', marginTop: '20px', flexDirection: 'column' }}>
                <span style={{ lineHeight: '30px', fontFamily: 'PingFang SC Regular', color: '#000000' }}><span
                  style={{ color: 'red' }}
                >
                </span>人群描述：
                </span>
                <Input
                  onChange={(value) => {
                    setRefreshParams({ ...refrshParams, description: value });
                  }}
                  maxLength={32}
                  value={refrshParams.description}
                  hasLimitHint
                  aria-label="Medium"
                  style={{ width: '100%', borderRadius: '2px' }}
                />
              </div>
            </div>
          </div>
        </Dialog>
      </div>

      <Dialog
        v2
        title="云鹿转官方人群"
        visible={visible}
        footer={false}
        onClose={onClose}
        width={650}
      >
        <Form style={{ width: '100%' }} {...formItemLayout} colon>
          <FormItem label="人群名称" required requiredMessage="请输入人群名称">
            <Input value={formData.name} maxLength={37} showLimitHint onChange={(name) => {
              setFormData({name})
            }}/>
          </FormItem>
          <FormItem label="人群描述">
            <Input value={formData.desc} maxLength={37} showLimitHint onChange={(desc) => {
              setFormData({desc})
            }}/>
          </FormItem>
          <FormItem label={<span className={styles['tips-title']}>
            <span>人群包有效期</span>
            <Balloon.Tooltip
              popupClassName="popupClassName"
              align='t'
              trigger={<span className={`${styles['icon-style']} iconfont icon-icon4-33`}/>}
            >
              因官方限制，手动上传人群包为临时人群包，且有每日每店上传上限
            </Balloon.Tooltip>
          </span>} required={true} requiredMessage={'请选择人群包有效期'}>
            {
              <RadioGroup value={formData.crowdExpire} aria-labelledby="groupId" onChange={(crowdExpire) => {
                setFormData({crowdExpire})
              }}>
                <Radio key={1} id={1} value={1}>
                  <span style={{ color: '#333333' }}>15天</span>
                  <span style={{ color: '#ccc' }}>（每日上限 {shortDayTimes}/50 次）</span>
                </Radio>
                <Radio key={2} id={2} value={2}>
                  <span style={{ color: '#333333' }}>365天</span>
                  <span style={{ color: '#ccc' }}>（每日上限 {longDayTimes}/5 次）</span>
                </Radio>
              </RadioGroup>
            }
          </FormItem>
        </Form>
        <div className={styles.bottomBtns}>
          <Button
            type="normal"
            className={`${styles.w88} ${styles.mr10}`}
            onClick={onClose}
          >
            关闭
          </Button>
          <Button type="primary" className={`${styles.w88}`} onClick={onCrowdSubmit} loading={submitLoading}>
            提交
          </Button>
        </div>
      </Dialog>

      <Dialog
        v2
        title="提示"
        visible={tipVisible}
        footer={false}
        onClose={tipClose}
      >
        <div>
          <i className={['iconfont', 'icon-a-outline32', styles.iconSucc].join(' ')} style={{fontSize: '33px', fontWeight: "normal"}}/>
          <div style={{fontSize: '15px', fontWeight: 'bold', marginBottom: 13}}>正在生成中......</div>
          <div>
            <span style={{color: '#666'}}>可在</span> <span style={{fontWeight: 'bold'}}>人群管理-我的人群库</span> <span style={{color: '#666'}}>中查看进度并管理</span><br/>
          </div>
        </div>
      </Dialog>
    </div>


  );
};

